<template>
    <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 0c4.96 0 9 4.04 9 9s-4.04 9-9 9-9-4.04-9-9 4.04-9 9-9zm0 1.6C4.92 1.6 1.6 4.92 1.6 9s3.32 7.4 7.4 7.4 7.4-3.32 7.4-7.4S13.08 1.6 9 1.6zm-.15 5c.413 0 .75.336.75.79v6.52c0 .434-.337.79-.75.79s-.75-.356-.75-.79V7.39c0-.434.337-.79.75-.79zm0-3.6a1.05 1.05 0 1 1 0 2.1 1.05 1.05 0 0 1 0-2.1z" fill="#06B0F0" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconI',
};
</script>
